// Module
var code = `<h2 class="section-header">Loan batch payment upload history</h2>

<table ng-table="\$ctrl.tableConfig" class="table">
  <thead>
    <tr>
      <th>No</th>
      <th>FileId</th>
      <th>Uploaded on</th>
      <th>Uploaded by</th>
      <th>Remarks</th>
      <th>Invoice</th>
      <th>File name</th>
      <th>Rows count</th>
      <th>Errors count</th>
      <th/>
      <th/>
    </tr>
  </thead>
  <tr ng-repeat="batchFile in \$data">
    <td>{{\$index + 1 + (\$ctrl.tableConfig.page() - 1) * \$ctrl.tableConfig.count()}}</td>
    <td>{{batchFile.loanBatchFile.id}}</td>
    <td>{{batchFile.loanBatchFile.uploadedOn}}</td>
    <td>{{batchFile.uploadedBy}}</td>
    <td>{{batchFile.loanBatchFile.remarks}}</td>
    <td>{{batchFile.loanBatchFile.officialReceipt || batchFile.loanBatchFile.startingReceiptNumber}}</td>
    <td>{{batchFile.file.fileName}}</td>
    <td>{{batchFile.rowCount}}</td>
    <td>{{batchFile.errorsCount}}</td>
    <td>
      <button ng-click="\$ctrl.showErrorDetails(batchFile.loanBatchFile.id)" ng-if="batchFile.errorsCount > 0" class="btn btn-warning">Errors</button>
    </td>
    <td>
      <button ng-click="\$ctrl.showDetails(batchFile.loanBatchFile.id)" class="btn btn-primary">Payment details</button>
    </td>
  </tr>
</table>

<div ng-if="!\$ctrl.totalRowCount" class="empty-message">
  <span>Loan batch payment upload history is blank</span>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/loan-payment/batch-loan-payments-history.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;